export enum AddOnScopeModel {
  RESERVATION_ONLY = "reservation_only",
  RATE_ONLY = "rate_only",
  BOUTH = "reservation_and_rate",
}
